<template>
    <div class="controlretention-search">
        <b-row>
            <b-col md="10" sm="12">
                <PageTitle
                    icon="fa fa-search"
                    main="Registro"
                    sub="Controle de Retenções"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col xs="12">
                <b-button
                    size="sm"
                    title="Gerar Provisionamento"
                    @click="actionNewDirectOperation"
                    variant="dark"
                    class="mr-2 mt-2 fa fa-plus"
                >
                </b-button>
                <b-button
                    size="sm"
                    class="mt-2 fa"
                    :class="icon"
                    @click="loadControlRetentions()"
                    variant="dark"
                >
                </b-button>
            </b-col>
        </b-row>
        <hr />
        <b-row>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Data Início:"
                    label-for="controlretention-search-start_date"
                >
                    <b-form-input
                        id="controlretention-search-start_date"
                        type="date"
                        v-model="start_date"
                        ref="inputsearch"
                        size="sm"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Data Término:"
                    label-for="controlretention-search-end_date"
                >
                    <b-form-input
                        id="controlretention-search-end_date"
                        type="date"
                        v-model="end_date"
                        size="sm"
                    />
                </b-form-group>
            </b-col>
            <b-col md="3" sm="12">
                <b-form-group
                    label="Empresa:"
                    label-for="controlretention-search-company_id"
                >
                    <b-form-select
                        id="controlretention-search-company_id"
                        size="sm"
                        :options="companys"
                        v-model="company_id"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Operação:"
                    label-for="controlretention-search-operation_id"
                >
                    <b-form-select
                        id="controlretention-search-operation_id"
                        size="sm"
                        @change="loadRetentions"
                        :options="operations"
                        v-model="operation_id"
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="5" sm="12">
                <b-form-group
                    label="Retenção:"
                    label-for="controlretention-search-retention_id"
                >
                    <b-form-select
                        id="controlretention-search-retention_id"
                        @input="loadControlRetentions"
                        @change="loadControlRetentions"
                        size="sm"
                        :options="retentions"
                        v-model="retention_id"
                    />
                </b-form-group>
            </b-col>
            <b-col md="5" sm="12">
                <div class="stats">
                    <Stat
                        title="Total Retido"
                        :value="this.total_retention"
                        color="#3282cd"
                    />
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12" sm="12">
                <template>
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                    ></b-pagination>
                    <transition name="slide" type="animation" appear>
                        <b-table
                            id="my-table"
                            class="table-responsive"
                            :per-page="perPage"
                            :current-page="currentPage"
                            v-show="showTable"
                            hover
                            key="slide"
                            head-variant="light"
                            :items="controlretentions"
                            :fields="fieldsControlRetention"
                        >
                            <template v-slot:cell(actions)="data">
                                <b-button
                                    title="Agrupar registro"
                                    size="sm"
                                    variant="light"
                                    @click="addRetention(data.item)"
                                    class="mr-2 mt-2 fa fa-plus"
                                >
                                </b-button>
                            </template>
                        </b-table>
                    </transition>
                </template>
            </b-col>
        </b-row>
        <b-modal
            id="modalDocument"
            ref="modal"
            size="lg"
            title-tag="h6"
            title="Registro de Lançamento"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveNewRelease"
        >
            <b-form>
                <b-row>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Data de Emissão:"
                            label-for="release-issue_date"
                        >
                            <b-form-input
                                id="release-issue_date"
                                type="date"
                                title="ALT+H (DATA ATUAL)"
                                v-on:keyup.alt.72="setDateToday"
                                v-model="release.issue_date"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="2" sm="12">
                        <b-form-group
                            label="Nº de Lançamento:"
                            label-for="release-release_number"
                        >
                            <b-form-input
                                id="release-release_number"
                                v-model="release.release_number"
                                type="number"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { baseApiUrl, showError, searchglobalkey } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
import Stat from '../home/Stat'
var moment = require('moment-timezone')

export default {
    name: 'ControlRetention',
    components: { PageTitle, Stat },
    data: function() {
        return {
            mode: 'insert',
            modeControlRetention: 'insert',
            start_date: null,
            end_date: null,
            operation_id: null,
            company_id: null,
            retention_id: null,
            total_retention: 0,
            search: '',
            boxCancel: '',
            controlretention: {},
            release: {},
            controlretentions: [],
            operations: [],
            companys: [],
            retentions: [],
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            showTable: false,
            perPage: 5,
            currentPage: 1,
            fieldsControlRetention: [
                {
                    key: 'base_date',
                    label: 'Data Base',
                    sortable: true,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : '',
                },
                { key: 'name_entity', label: 'Razão Social', sortable: true },
                { key: 'name_reduced', label: 'Tipo Doc.', sortable: false },
                { key: 'release_number', label: 'Nº.', sortable: false },
                {
                    key: 'base_retention_value',
                    label: 'Valor Base',
                    sortable: false,
                },
                {
                    key: 'percent',
                    label: '% Retido',
                    sortable: false,
                },
                {
                    key: 'retention_value',
                    label: 'Valor Retido',
                    sortable: false,
                },
                { key: 'actions', label: 'Ações' },
            ],
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        compan() {
            return this.$store.state.compan
        },
        searchglobal() {
            return this.$store.state.searchglobal
        },
        icon() {
            return this.showTable ? 'fa-retweet' : 'fa-search'
        },
        rows() {
            return this.controlretentions.length
        },
    },
    methods: {
        showMsgBoxDeleted(controlretention) {
            this.boxCancel = ''
            this.$bvModal
                .msgBoxConfirm('Deseja Excluir o Registro ?', {
                    title: 'Por Favor Confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeControlRetention(controlretention)
                    }
                })
        },
        showMsgBoxAllow(controlretention) {
            this.boxCancel = ''
            this.$bvModal
                .msgBoxConfirm('Deseja confirmar o registro ?', {
                    title: 'Por favor confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then(value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        this.allowControlRetention(controlretention)
                    }
                })
        },

        formatDate(date) {
            return moment
                .utc(date)
                .local()
                .format('YYYY-MM-DD')
        },
        async loadControlRetentions() {
            const url = `${baseApiUrl}/releaseretentionsearchdate/${this.company_id}/?start_date=${this.start_date}&end_date=${this.end_date}&retention_id=${this.retention_id}&operation_id=${this.operation_id}`
            await axios.get(url).then(res => {
                this.controlretentions = res.data
            })

            this.controlretentions.map(row => {
                this.total_retention = +parseFloat(row.retention_value).toFixed(
                    2
                )
            })
        },
        async canceledControlRetention(controlretention) {
            this.controlretention = { ...controlretention }

            if (this.controlretention.id) {
                this.controlretention.user_canceled_id = this.user.id
                this.controlretention.canceled_date = this.formatDate(
                    moment.utc().local()
                )

                this.controlretention.document_status_id = 5

                const method = this.controlretention.id ? 'put' : 'post'
                const id = this.controlretention.id
                    ? `/${this.controlretention.id}`
                    : ''
                await axios[method](
                    `${baseApiUrl}/controlretentions${id}`,
                    this.controlretention
                )
                    .then(async () => {
                        this.$toasted.global.defaultSuccess()
                        await this.loadControlRetentions()
                    })
                    .catch(showError)
            }
        },
        async removeControlRetention(controlretention) {
            const id = controlretention.id
            await axios
                .delete(`${baseApiUrl}/controlretentions/${id}`)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadControlRetentions()
                })
                .catch(showError)
        },
        addRetention(controlretention) {
            const id = controlretention.id
            axios
                .post(`${baseApiUrl}/controlretentions/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadControlRetentions()
                })
                .catch(showError)
        },
        loadCompanys() {
            const url = `${baseApiUrl}/companys`
            axios.get(url).then(res => {
                this.companys = res.data.map(company => {
                    return { value: company.id, text: company.name_company }
                })
            })
        },
        actionNewControlRetention() {
            this.searchsetparms = {}
            this.$store.commit('setSearchGlobal', null)
            localStorage.removeItem(searchglobalkey)

            this.searchsetparms = {
                start_date_release: this.start_date,
                end_date_release: this.end_date,
                company_id_release: this.company_id,
            }
            this.$store.commit('setSearchGlobal', this.searchsetparms)
            localStorage.setItem(
                searchglobalkey,
                JSON.stringify(this.searchsetparms)
            )

            if (!this.compan) {
                this.$toasted.global.defaultWarning({ msg: 'Logar na Empresa' })
            } else {
                const controlretention = {}
                controlretention.document_status_id = 1
                this.$router.push({
                    name: 'RecordControlRetention',
                    query: { controlretentionbase: controlretention },
                })
            }
        },

        loadOperation() {
            const url = `${baseApiUrl}/operations`
            axios.get(url).then(res => {
                this.operations = res.data.map(operation => {
                    return {
                        value: operation.id,
                        text: operation.name_operation,
                    }
                })
            })
            this.$refs.inputsearch.focus()
        },
        async loadRetentions() {
            const url = `${baseApiUrl}/retentions/?operation_id=${this.operation_id}`
            await axios.get(url).then(res => {
                this.retentions = res.data.map(retention => {
                    return {
                        value: retention.id,
                        text:
                            retention.name_retention +
                            '-' +
                            retention.code_retention,
                    }
                })
            })
        },
    },
    mounted() {
        this.loadCompanys()
        this.loadOperation()
        this.showTable = true

        if (this.searchglobal) {
            this.start_date = moment(
                this.searchglobal.start_date_release
            ).format('YYYY-MM-DD')
            this.end_date = moment(this.searchglobal.end_date_release).format(
                'YYYY-MM-DD'
            )
            this.company_id = this.searchglobal.company_id_release
            this.operation_id = this.searchglobal.operation_release
        } else {
            if (!this.compan) {
                this.$toasted.global.defaultWarning({ msg: 'Logar na Empresa' })
            } else {
                this.start_date = moment()
                    .startOf('month')
                    .format('YYYY-MM-DD')
                this.end_date = moment()
                    .endOf('month')
                    .format('YYYY-MM-DD')
                this.company_id = this.compan.id
                this.loadControlRetentions()
            }
        }
    },
}
</script>

<style>
.controlretention-search {
    font-size: 0.7rem;
}

.controlretention-search input,
label,
form {
    font-size: 0.7rem;
}
.controlretention-search button {
    font-size: 0.7rem;
}

.controlretention-search select {
    font-size: 0.7rem;
}

.controlretention-search table {
    font-size: 0.7rem;
}

#modalAccounting {
    font-size: 0.7rem;
}

#modalAccounting button {
    font-size: 0.7rem;
}
#modalAccounting input,
label,
form {
    font-size: 0.7rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
